// extracted by mini-css-extract-plugin
module.exports = {"slide":"DetailOrdersProduct_slide_LoxUL","slide-reverse":"DetailOrdersProduct_slide-reverse_DkFa6","sm":"DetailOrdersProduct_sm_1YHq5"};